import { BlockModule } from '@/website/blocks/common'
import FileSharingDownloadButton from './components/FileSharingDownloadButton.vue'
import { defineComponent } from 'vue'
import FileSharingDownload from './components/FileSharingDownload.vue'

new BlockModule({
    selector: '.block-file-sharing-download',
    vueComponent: defineComponent({
        components: {
            FileSharingDownloadButton,
            FileSharingDownload,
        },
    }),
})
